//CommentCard

import React, { useState } from "react";
import "./css/CommentCard.css";
import ChatRoundedIcon from "@mui/icons-material/ChatRounded";
import ReplyCard from "./ReplyCard";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Avatar } from "@mui/material";

const CommentCard = ({
  content,
  cId,
  bId,
  uId,
  commentUserName,
  repliesArray,
  time,
}) => {
  const [showReplies, setShowReplies] = useState(false);
  const [reply, setReply] = useState(false);
  const navigate = useNavigate();
  //for reply text
  const [replyText, setReplyText] = useState({ replyText: "" });

  //toggling functions for reply and view reply options
  const handleViewReply = () => {
    setShowReplies((prevShowReplies) => !prevShowReplies);
  };
  // ...
  const handleReply = () => {
    setReply((prevReply) => !prevReply);
  };
  //handle input change
  const handleChange = (e) => {
    setReplyText((prevState) => ({
      ...prevState,
      replyText: e.target.value,
    }));
  };

  const [avatarSrc, setAvatarSrc] = React.useState(
    `${process.env.PUBLIC_URL}/images/defaultAvatar.jpg`
  );

  const handleAvatarError = () => {
    setAvatarSrc(`${process.env.PUBLIC_URL}/images/defaultAvatar.jpg`);
  };
  return (
    //showing comments
    <div className="commentContainer">
      <div className="commentCard">
        <div className="userDetail">
          <div className="logoUsernameContainer">
            <Avatar
              src={avatarSrc}
              onError={handleAvatarError}
              alt="Avatar"
              sx={{ width: 29, height: 29, boxShadow: " 0px 0px 2px 0px grey" }}
            />
            <div className="username">{commentUserName}</div>
          </div>
          <div className="time">{new Date(time).toLocaleDateString()}</div>
        </div>
        <div className="textArea">{content}</div>
        <div className="buttonArea">
          <div className="replyBtnContainer">
            <div className="reply" onClick={handleViewReply}>
              <div className="icon">
                <ChatRoundedIcon />
              </div>
              <div className="replyCount">
                {showReplies ? "Hide replies" : "View replies"}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* showing replies */}
      {showReplies &&
        repliesArray.map((i) => (
          <ReplyCard
            content={i.reply_content}
            replyUsername={i.user_id.name}
            time={i.time}
          />
        ))}
    </div>
  );
};

export default CommentCard;
